module.exports = __webpack_public_path__ + "static/media/21-5.1f50649b.mp3";